/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue} from 'vue-property-decorator'
import {formatDate} from '@/utils/timeFilter'
import {
    getDownloadFinanceContractById,
    getFinanceContractInfoById,
    updFinanceContractById
} from '@/api/financial-center'
import {menuBtn} from '@/utils/menu_level2_button'
import * as math from "mathjs";

import {makeUploadSignature} from "@/utils/uploadMd5";

@Component({})
export default class ContractStudentInfo extends Vue {
    logShow = true
    contractId = NaN
    contractInfo: any = {}
    status = ''
    isUpdatedData = '0'
    activities = []
    elImageUrls = []
    fileTypeslist: any = [
        {name: '学生合同', val: '0'},
        {name: '代理合同', val: '1'},
        {name: '高校合同', val: '2'}
    ]

    menuBtn = menuBtn
    downloadUrl = ''
    contractCode = ''
    isShow = ''
    loading = false
    openContrDialog = false
    previewName = ''
    previewVisible = false
    previewPath = ''
    fileList = []
    contractLoading = false
    disBtn = false
    uploadSignCompleteUrl = ''
    orderPrice = 0
    uploadData = {
        bucket: 'crm',
        signature: ''
    }

    created() {
        this.contractId = this.$route.query.id as unknown as number
        this.status = this.$route.query.status as string

        this.getFinanceContractInfoById()
    }

    formatDate = formatDate

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    async getFinanceContractInfoById() {
        this.loading = true
        await getFinanceContractInfoById({id: this.contractId}).then((data: any) => {
            this.contractInfo = data.financeContract
            this.contractInfo.contractAt = this.contractInfo.contractAt.replace(/&/g, ",");
            this.downloadUrl = data.financeContract.downloadUrl
            this.contractCode = data.financeContract.code
            this.isShow = data.financeContract.isShow
            this.activities = data.financeContract.messageReviewList
            if (this.contractInfo.commissionType == '1') {
                this.orderPrice = math.number(math.subtract(math.bignumber(Number(this.contractInfo.priceOrRatio)), math.bignumber(Number(this.contractInfo.discountPrice))));
            } else {
                this.orderPrice = math.number(math.subtract(math.bignumber(Number(this.contractInfo.souCoursePrice)), math.bignumber(Number(this.contractInfo.discountPrice))));
            }
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }

    clickEditButton() {
        if (this.status === '审批中') {
            this.$message.error('审批中，不可编辑')
            return
        }
        this.$router.push({
            path: 'contractAddAgent',
            query: {
                contractId: String(this.contractId),
                isUpdatedData: '0'
            }
        })
    }


    // 预览
    previewContract() {
        window.open(this.downloadUrl, 'blank')
    }

    previewContractUrl() {
        window.open(this.contractInfo.url, 'blank')
    }

    // 查询签署结果
    queryResult() {
        getDownloadFinanceContractById({
            id: this.contractId
        }).then(() => {
            // 重新刷新页面
            location.reload();
        }).catch((err) => {
            console.log(err)
        })
    }


    openDialogOfContract() {
        this.openContrDialog = true
    }

    uploadSuccess(res) {
        const {data} = res
        // this.editFiles.downloadUrl = data.ossUrl

        if (Object.keys(data).length === 0) {
            if (data.error.returnCode !== 0)
                this.$message.error(data.error.returnMessage)
            this.contractLoading = false
        } else {
            this.uploadSignCompleteUrl = data.ossUrl
            this.$message.success('上传成功')
            this.contractLoading = false
        }
    }

    uploadError() {
        this.$message.error('上传失败')
    }

    handlePreview(file) {
        if (file.response) {
            this.previewPath = file.response.data.url
        } else {
            this.previewPath = file.url
        }
        this.previewName = file.name
        this.previewVisible = true
    }

    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }

    changeFile(file, fileList) {
        if (fileList.length > 1) {
            fileList.splice(0, 1);
        }
        this.fileList = fileList;
    }

    beforeUpload(file) {
        this.contractLoading = true;//上传时显示
        this.$message("正在上传中，请稍后")
        // 1. 为当前文件实时生成专属 signature，并同步更新全局 uploadData
        const currentSignature = makeUploadSignature('crm', file.name);
        // this.uploadData.signature = currentSignature; // 同步更新，立即生效
        this.$set(this.uploadData, 'signature', currentSignature);
    }

    handleCloseContr() {
        this.openContrDialog = false
        this.contractLoading = false
    }

    // 确定
    async handleConfirmContr() {
        if(this.uploadSignCompleteUrl === '') {
            this.$message.error('请上传文件')
            return
        }
        await updFinanceContractById({
            id: Number(this.contractId),
            url: this.uploadSignCompleteUrl
        }).then(() => {
            this.downloadUrl = this.uploadSignCompleteUrl
            this.$message.success('上传成功')
            this.uploadSignCompleteUrl = ''
        }).catch((err) => {
            console.log(err)
        })
        this.openContrDialog = false
    }

}
